import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Container, Grid, Typography, Link as MuiLink, IconButton } from '@mui/material';
import { Facebook, Twitter, Instagram, LinkedIn, LocalHospital } from '@mui/icons-material';

const Footer = () => {
  return (
    <Box component="footer" sx={{ bgcolor: '#1976d2', color: 'white', py: 6, mt: 'auto' }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} sm={4}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <LocalHospital sx={{ mr: 1 }} />
              <Typography variant="h6" fontWeight="bold">
                سیستم نوبت دهی پزشکی
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ mb: 2 }}>
              سامانه آنلاین نوبت دهی پزشکی با امکان مشاهده پروفایل پزشکان، رزرو آنلاین نوبت و مدیریت قرارهای ملاقات پزشکی
            </Typography>
            <Box sx={{ display: 'flex' }}>
              <IconButton color="inherit" aria-label="facebook" size="small">
                <Facebook />
              </IconButton>
              <IconButton color="inherit" aria-label="twitter" size="small">
                <Twitter />
              </IconButton>
              <IconButton color="inherit" aria-label="instagram" size="small">
                <Instagram />
              </IconButton>
              <IconButton color="inherit" aria-label="linkedin" size="small">
                <LinkedIn />
              </IconButton>
            </Box>
          </Grid>
          
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              لینک های مفید
            </Typography>
            <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0 }}>
              <Box component="li" sx={{ mb: 1 }}>
                <MuiLink component={Link} to="/" color="inherit" underline="hover">
                  صفحه اصلی
                </MuiLink>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <MuiLink component={Link} to="/doctors" color="inherit" underline="hover">
                  جستجوی پزشکان
                </MuiLink>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <MuiLink component={Link} to="/appointments" color="inherit" underline="hover">
                  قرارملاقات های من
                </MuiLink>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <MuiLink component={Link} to="/about" color="inherit" underline="hover">
                  درباره ما
                </MuiLink>
              </Box>
              <Box component="li" sx={{ mb: 1 }}>
                <MuiLink component={Link} to="/contact" color="inherit" underline="hover">
                  تماس با ما
                </MuiLink>
              </Box>
            </Box>
          </Grid>
          
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              تماس با ما
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              آدرس: تهران، خیابان ولیعصر، خیابان بهشتی، پلاک ۴۲
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              تلفن: ۸۸۷۷۶۶۵۵-۰۲۱
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              پست الکترونیکی: info@doctor-appointment.com
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              ساعات کاری: شنبه تا پنجشنبه، ۸ صبح تا ۸ شب
            </Typography>
          </Grid>
        </Grid>
        
        <Box mt={5} textAlign="center">
          <Typography variant="body2">
            {`کلیه حقوق این سایت محفوظ است © ${new Date().getFullYear()}`}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;